import axios from "@/axios"

const url = "/api/brain/specimens/colors"

class SpecimenColorService {
	async getSpecimenByColor(params) {
		try {
			const { data } = await axios.get(`${url}/specimens`, { params })
			return data
		} catch (error) {
			throw error
		}
	}
	async getColorsToSelect(params) {
		try {
			const { data } = await axios.get(`${url}/select`, { params })
			return data
		} catch (error) {
			throw error
		}
	}
	async changeSpecimensColor(params) {
		try {
			const { data } = await axios.post(`${url}/change-specimen-color`, params)
			return data
		} catch (error) {
			throw error
		}
	}
}

export default new SpecimenColorService()
